
import Pagehelmet from "./Pagehelmet";
import SpeakersSection from "../Components/SpeakerSection";
import SpeakerForm from "../Components/SpeakerForm";
import SpeakerPass from "../Components/SpeakerPass";

const BecomeSpeaker = () => {


  return (
      <div>
      <Pagehelmet pageTitle="Become A Speaker" />
<SpeakerForm/>
<SpeakerPass/>
<SpeakersSection/>


      
 
   
    </div>
  )
}

export default BecomeSpeaker